import React, {ReactElement} from 'react';
import {Alignment} from '../../../types';
import DynamicLink from '../../DynamicLink/DynamicLink';
import Headers, {HeaderType} from '../Text/Headers/Headers';

import './HubPageLink.scss';

export interface HubPageLinkProps {
  href: string;
  title: string;
  imageSrc: string;
  className?: string;
}

function HubPageLink({href, title, imageSrc, className}: HubPageLinkProps): ReactElement {
  return (
    <DynamicLink href={href} className={`hubPageLink unstyledLink ${className || ''}`.trim()}>
      <img className="hubPageLink__image" src={imageSrc} alt={title} />
      <Headers headerType={HeaderType.H4} alignment={Alignment.CENTER} className="hubPageLink__title">
        {title}
      </Headers>
    </DynamicLink>
  );
}

export default HubPageLink;
